export default {
  copyTrading: {
    'tooltip-title1': 'Smart Copy - Platform Only, No MT Account Required',
    'tooltip-title2': 'Standard MT4/MT5 Copy - Platform Accounts Only',
    'tooltip-title3': 'Cross-Platform Copy - Any Broker MT Account',
    'tab-label-gtc': 'Smart Copy',
    'tab-label-in': 'Standard MT4/MT5 Copy',
    'tab-label-out': 'Cross-Platform Copy',
    'bullet-label-mode': 'Mode & Advantages:',
    'bullet-label-profit': 'Profit Sharing Cycle:',
    'bullet-label-stop': 'Take Profit & Stop Loss:',
    'bullet-label-direction': 'Copy Direction:',
    'bullet-label-method': 'Copy Method:',
    'tooltip1-mode-desc':
      'Mirror signal source entirely; identical entry price and timing; followers do not need an MT account.',
    'tooltip1-profit-desc': `Revenue shares are distributed when the signal provider's cycle ends or the copy stops.`,
    'tooltip1-stop-desc':
      'Stop-loss amount cannot be set; you can stop copying manually at any time.',
    'tooltip1-direction-desc': 'Only forward copy is supported.',
    'tooltip2-mode-desc': 'Supports subscription fee charging model.',
    'tooltip2-profit-desc': 'Platform distributes at unified expiry or when the copy is cancelled.',
    'tooltip2-stop-desc':
      'Automatically stops copying when preset take-profit/stop-loss is reached.',
    'tooltip2-method-desc': 'Supports positive/negative, proportional, and symbol-suffix matching.',
    'tooltip3-mode-desc': 'Supports subscription fee charging model.',
    'tooltip3-profit-desc': 'Platform distributes at unified expiry or when the copy is cancelled.',
    'tooltip3-stop-desc': 'Does not stop copying when take-profit/stop-loss is reached.',
    'tooltip3-method-desc': 'Supports positive/negative, proportional, and symbol-suffix matching.',
  },
  gtcCopy: {
    'tab-open-orders': 'Open Orders',
    'tab-close-orders': 'Closed Orders',
    'tab-active': 'Active',
    'tab-closing': 'Closing',
    'tab-closed': 'Closed',
    'tag-all': 'All',
    'tag-recommend': 'Recommended Signals',
    'tag-view': 'Recently Viewed',
    'tag-earning-desc': 'Highest Return',
    'tag-drawdown-asc': 'Lowest Drawdown',
    'tag-followers-desc': 'Most Copied',
    'search-placeholder': 'Search signal name or publisher',
    'load-more': 'Load More',
    'empty-active': 'No active copy trades yet',
    'empty-closing': 'No copy trades stopping',
    'empty-closed': 'No copy trades stopped',
    'view-signal': 'Browse Copy Signals',
    'total-assets': 'Total Assets',
    'investment-equity': 'Investment Equity',
    'member-wallet': 'Member Wallet',
    'currency-usd': 'USD',
    'summary-total-earn': 'Total P&L:',
    'summary-order-profit': 'Order P&L:',
    'summary-interest': 'Interest:',
    'summary-commission': 'Commission:',
    'order-buy': 'Buy',
    'order-sell': 'Sell',
    'order-lot-suffix': ' lots',
    'order-buy-short': 'Buy',
    'order-sell-short': 'Sell',
    'no-value': 'None {value}',
    'label-open-price': 'Open Price',
    'label-interest': 'Interest',
    'label-follow-ratio': 'Copy Ratio',
    'label-volume': 'Volume',
    'label-profit': 'Profit',
    'label-open-time': 'Open Time',
    'column-symbol-info': 'Symbol Info',
    'column-open-price': 'Open Price',
    'column-profit': 'Profit',
    'column-symbol': 'Symbol',
    'column-ticket': 'Ticket',
    'column-direction-volume': 'Direction / Volume',
    'column-close-price': 'Close Price',
    'column-interest': 'Interest',
    'column-commission': 'Commission',
    'column-open-time': 'Open Time',
    'column-close-time': 'Close Time',
    'copy-success-title': 'Copy Successful',
    'copy-success-message': 'Order ID copied successfully',
    'copy-fail-title': 'Copy Failed',
    'copy-fail-message': 'Failed to copy order ID',
    'report-confirm': 'Confirm',
    'report-reset': 'Reset',
    'report-total-highwater-profit': 'Total High-Water P&L:',
    'report-total-copy-earn': 'Total Copy Returns:',
    'report-total-performance-fee': 'Total Performance Fee:',
    'report-column-settle-period': 'Settlement Period',
    'report-column-copy-id': 'Investment ID',
    'report-column-member-id': 'Client ID',
    'report-column-total-investment': 'Investment Amount',
    'report-column-highwater-line': 'High-Water Line',
    'report-column-ending-equity': 'Ending Equity',
    'report-column-highwater-profit': 'High-Water P&L',
    'report-column-copy-earn': 'Copy Returns',
    'report-column-performance-fee': 'Performance Fee',
    'report-column-settle-time': 'Settlement Time',
    'report-column-strategy-earn': 'Signal Profit',
    'pagination-total': 'Total {total}',
    'detail-invest-time': 'Investment Time:',
    'detail-stop-time': 'Stop Time:',
    'detail-submit-time': 'Submitted:',
    'detail-invest-amount': 'Investment Amount',
    'detail-profit': 'P&L',
    'detail-equity': 'Equity',
    'detail-earn': 'Earnings',
    'detail-performance-fee': 'Performance Fee',
    'detail-add-funds': 'Add Funds',
    'detail-stop-copy': 'Stop Copying',
    'tab-order': 'Orders',
    'tab-report': 'Reports',
    'discover-recommend-title': 'Recommended Signals',
    'discover-recent-title': 'Recently Viewed',
    'discover-earning-title': 'Top Returns',
    'discover-drawdown-title': 'Lowest Drawdown',
    'discover-followers-title': 'Most Copied',
    'discover-all-title': 'All Signals',
    'discover-view-all': 'View All',
    'discover-tag-recommend': 'Recommended',
    'my-publish-create': 'Create Copy Signal',
    'my-publish-tab-active': 'Active',
    'my-publish-tab-archive': 'Archived',
    'my-publish-total-networth': 'Total Net Worth',
    'my-publish-total-signal-equity': 'Total Signal Equity',
    'my-publish-total-copy-amount': 'Total Copy Amount',
    'my-share-filter-type': 'Type',
    'my-share-option-recommend': 'Recommended',
    'my-share-option-share': 'Shared',
    'my-share-button-search': 'Search',
    'my-share-button-reset': 'Reset',
    'my-share-column-id': 'Signal ID',
    'my-share-column-name': 'Signal Name',
    'my-share-column-follower': 'Follower',
    'my-share-column-type': 'Type',
    'my-share-column-copy-amount': 'Copy Amount',
    'my-share-column-share-amount': 'My Sharing Commission',
    'my-share-column-invite-amount': 'My Referral Commission',
    'my-share-column-status': 'Status',
    'my-share-column-subscribe-time': 'Subscription Time',
    'my-share-column-action': 'Action',
    'my-share-tag-share': 'Sharing',
    'my-share-tag-recommend': 'Recommended',
    'my-share-status-pending-settle': 'Pending Settlement',
    'my-share-status-pending-redeem': 'Pending Redemption',
    'my-share-status-subscribing': 'Subscribed',
    'my-share-status-stopped': 'Stopped',
    'my-share-action-detail': 'Details',
    'follower-column-nickname': 'Follower',
    'follower-column-investment': 'Investment Amount',
    'follower-column-profit': 'Profit & Loss',
    'create-step-account': 'Account Info',
    'create-step-signal': 'Signal Info',
    'create-label-server-type': 'Server Type',
    'create-placeholder-server-type': 'Select server type',
    'create-label-account-type': 'Account Type',
    'create-placeholder-account-type': 'Select account type',
    'create-label-leverage': 'Leverage',
    'create-placeholder-leverage': 'Select leverage',
    'create-label-currency': 'Currency',
    'create-placeholder-currency': 'Currency',
    'create-label-name': 'Signal Name',
    'create-placeholder-name': 'Enter signal name',
    'create-label-performance-fee': 'Performance Fee',
    'create-placeholder-performance-fee': 'Enter value 0-50',
    'create-label-min-deposit': 'Minimum Investment Amount',
    'create-placeholder-min-deposit': 'Enter amount {min}-{max}',
    'create-label-settle-cycle': 'Settlement Cycle',
    'create-placeholder-settle-cycle': 'Select settlement cycle',
    'create-placeholder-settle-interval': 'Select settlement interval',
    'create-label-photo': 'Signal Photo',
    'create-label-description': 'Trading Description',
    'create-share-toggle': 'Sharer Commission',
    'create-optional': '(Optional)',
    'create-placeholder-share-rate': 'Level {level} sharer commission rate',
    'create-invite-toggle': 'Invitee Commission',
    'create-table-commission-level': 'Commission Level',
    'create-table-commission-rate': 'Commission Rate',
    'create-invite-level-label': 'Level {level} Invitee',
    'create-placeholder-invite-rate': 'Level {level} invitee commission rate',
    'create-button-prev': 'Previous',
    'create-button-confirm': 'Confirm',
    'create-success-title': 'Signal Created',
    'create-success-desc': 'Signal {name} created successfully',
    'create-success-view': 'View Signal',
    'create-success-deposit': 'Deposit',
    'create-notify-success-title': 'Action Successful',
    'create-notify-success-desc': 'Signal created successfully',
    'create-notify-fail-title': 'Action Failed',
    'create-notify-fail-desc': 'Failed to create signal',
    'create-error-select-server': 'Please select a server type',
    'create-error-select-account': 'Please select an account type',
    'create-error-select-leverage': 'Please select a leverage',
    'create-error-select-currency': 'Please select a currency',
    'create-error-input-name': 'Please enter a signal name',
    'create-error-name-length': 'Signal name cannot exceed 40 characters',
    'create-error-input-performance-fee': 'Please enter a performance fee',
    'create-error-performance-fee-range': 'Performance fee must be between 0 and 50',
    'create-error-input-min-deposit': 'Please enter the minimum investment amount',
    'create-error-min-deposit-range': 'Minimum investment amount must be between {min}-{max}',
    'create-error-select-photo': 'Please select a signal photo',
    'create-error-input-description': 'Please enter a trading description',
    'create-error-description-length': 'Trading description cannot exceed 320 characters',
    'create-error-select-settle-cycle': 'Please select a settlement cycle',
    'create-error-select-settle-interval': 'Please select a settlement interval',
    'create-error-commission-range': 'Total commission must be between 0 and 100',
    'create-range-label-minutes': 'By Minute',
    'create-range-label-hours': 'By Hour',
    'create-range-label-days': 'By Day',
    'create-range-label-months': 'By Month',
    'create-range-label-years': 'By Year',
    'create-range-num-minutes': '{value} minutes',
    'create-range-num-hours': '{value} hours',
    'create-range-num-days': '{value} days',
    'create-range-num-months': '{value} months',
    'create-range-num-years': '{value} years',
    'order-entry-in': 'In',
    'order-entry-out': 'Out',
    'order-column-entry': 'Trend',
    'order-column-tp': 'Take Profit',
    'order-column-sl': 'Stop Loss',
    'overview-section-intro': 'Strategy Introduction',
    'overview-section-summary': 'Overview',
    'overview-summary-strategy-equity': 'Strategy Equity',
    'overview-summary-minimum-deposit': 'Minimum Investment',
    'overview-summary-available-amount': 'Available Amount',
    'overview-summary-follower-count': 'Followers',
    'overview-summary-leverage': 'Leverage',
    'overview-summary-publish-date': 'Published Date',
    'overview-section-analysis': 'Signal Analysis',
    'overview-analysis-profit-loss-orders': 'Winning / Losing Orders',
    'overview-analysis-buy-sell-orders': 'Buy / Sell Orders',
    'overview-analysis-profit-loss-weeks': 'Winning / Losing Weeks',
    'overview-analysis-trade-count': 'Total Trades',
    'overview-analysis-trade-per-week': 'Avg. Trades per Week',
    'overview-analysis-avg-trade-hours': 'Avg. Trade Duration (hours)',
    'overview-analysis-consecutive-profit': 'Consecutive Wins',
    'overview-analysis-consecutive-loss': 'Consecutive Losses',
    'overview-section-trade-pl': 'Trading P&L',
    'overview-pl-profit': 'Profit',
    'overview-pl-loss': 'Loss',
    'overview-pl-ratio': 'Profit-Loss Ratio',
    'overview-pl-total': 'Net P&L',
    'overview-pl-max-daily-profit': 'Max Daily Profit',
    'overview-pl-max-daily-loss': 'Max Daily Loss',
    'overview-section-settlement': 'Settlement Cycle',
    'overview-progress-remaining': 'Remaining {time}',
    'overview-tab-profit': 'Returns',
    'overview-tab-equity': 'Equity',
    'overview-range-1year': '1 Year',
    'overview-range-6months': '6 Months',
    'overview-range-3months': '3 Months',
    'overview-range-1month': '1 Month',
    'overview-range-7days': '7 Days',
    'overview-section-monthly-profit': 'Monthly Returns',
    'overview-section-monthly-risk': 'Monthly Risk Levels',
    'overview-section-trade-stats': 'Trading Breakdown',
    'time-format-year': '{value} year(s)',
    'time-format-month': '{value} month(s)',
    'time-format-day': '{value} day(s)',
    'time-format-hour': '{value} hour(s)',
    'time-format-minute': '{value} minute(s)',
    'time-format-second': '{value} second(s)',
    'signal-details-manager': 'Manager',
    'signal-details-no-desc': 'No introduction available',
    'signal-details-total-return': 'Total Return',
    'signal-details-max-drawdown': 'Max Drawdown',
    'signal-details-risk-level': 'Risk Level',
    'signal-details-risk-level-denominator': '/10',
    'signal-details-performance-fee': 'Performance Fee',
    'signal-details-follow-now': 'Copy Now',
    'signal-details-share': 'Share',
    'signal-details-tab-overview': 'Overview',
    'signal-details-tab-order': 'Orders',
    'signal-details-tab-follower': 'Followers',
    'signalReport-created-at': 'Created At:',
    'signalReport-principal': 'Signal Principal',
    'signalReport-min-deposit': 'Minimum Investment',
    'signalReport-share-commission': 'Sharer Commission',
    'signalReport-invite-commission': 'Invitee Commission',
    'signalReport-share-level': 'Level {level} {value}%',
    'signalReport-performance-fee': 'Performance Fee',
    'signalReport-follower-count': 'Followers',
    'signalReport-follower-tooltip': 'Current / Total',
    'signalReport-share-fee': 'Sharer Payout',
    'signalReport-invite-fee': 'Referral Payout',
    'signalReport-card-my-fee': 'My Performance Fee',
    'signalReport-card-copy-profit': 'Copy Profit',
    'signalReport-card-signal-profit': 'Signal Profit',
    'signalReport-card-copy-investment': 'Copy Capital',
    'signalReport-tab-report': 'Settlement Report',
    'signalReport-tab-record': 'Copy Records',
    'signalReport-summary-my-fee': 'My Performance Fee:',
    'signalReport-summary-copy-profit': 'Copy Profit:',
    'signalReport-summary-signal-profit': 'Signal Profit:',
    'signalReport-summary-copy-investment': 'Copy Capital:',
    'signalReport-report-filter-type': 'Filter by Status',
    'signalReport-filter-all': 'All',
    'signalReport-filter-stopping': 'Stopping',
    'signalReport-filter-running': 'Running',
    'signalReport-filter-stopped': 'Stopped',
    'signalReport-column-settle-period': 'Settlement Period',
    'signalReport-column-copy-id': 'Investment ID',
    'signalReport-column-member-id': 'Client ID',
    'signalReport-column-status': 'Status',
    'signalReport-column-total-investment': 'Copy Capital',
    'signalReport-column-copy-max-profit': 'High-Water P&L',
    'signalReport-column-copy-earn': 'Copy Returns',
    'signalReport-column-my-fee': 'My Performance Fee',
    'signalReport-column-settle-time': 'Settlement Time',
    'signalReport-column-follower-name': 'Follower',
    'signalReport-column-follow-id': 'Copy ID',
    'signalReport-column-follow-fee': 'Performance Fee',
    'signalReport-column-follow-amount': 'Copy Amount',
    'signalReport-column-follow-earn': 'Copy Returns',
    'signalReport-column-start-time': 'Start Time',
    'signalReport-column-end-time': 'End Time',
    'status-running': 'Running',
    'status-stopping': 'Stopping',
    'status-stopped': 'Stopped',
    'home-tab-discover': 'Discover',
    'home-tab-assets': 'My Copying',
    'home-tab-my-publish': 'My Releases',
    'home-tab-my-share': 'My Sharing / Referrals',
  },
  inCopy: {
    'search-order-placeholder': 'Search order ID, symbol, account, signal name',
    'filter-direction-placeholder': 'Trade Direction',
    'direction-buy': 'Buy',
    'direction-sell': 'Sell',
    'direction-buy-short': 'Buy',
    'direction-sell-short': 'Sell',
    'button-confirm': 'Confirm',
    'button-reset': 'Reset',
    'tag-copy': 'Copy',
    'tag-signal': 'Signal',
    'unit-lot': 'lots',
    'toggle-collapse': 'Collapse',
    'toggle-expand': 'Expand',
    'close-order-column-signal-name': 'Signal Name',
    'close-order-column-account': 'Account',
    'close-order-column-ticket': 'Order ID',
    'close-order-column-symbol': 'Symbol',
    'close-order-column-direction-volume': 'Direction / Volume',
    'close-order-column-open-price': 'Open Price',
    'close-order-column-close-price': 'Close Price',
    'close-order-column-profit': 'Copy Returns',
    'close-order-column-open-time': 'Open Time',
    'close-order-column-close-time': 'Close Time',
    'close-order-column-memo': 'Memo',
    'fail-order-column-signal-name': 'Signal Name',
    'fail-order-column-account': 'Account',
    'fail-order-column-ticket': 'Order ID',
    'fail-order-column-symbol': 'Symbol',
    'fail-order-column-direction-volume': 'Direction / Volume',
    'fail-order-column-operation': 'Operation',
    'fail-order-column-request-volume': 'Requested Volume',
    'fail-order-column-real-volume': 'Executed Volume',
    'fail-order-column-time': 'Time',
    'fail-order-column-memo': 'Memo',
    'operation-open': 'Open',
    'operation-close': 'Close',
    'success-order-column-signal-name': 'Signal Name',
    'success-order-column-account': 'Account',
    'success-order-column-ticket': 'Order ID',
    'success-order-column-symbol': 'Symbol',
    'success-order-column-direction-volume': 'Direction / Volume',
    'success-order-column-open-price': 'Open Price',
    'success-order-column-open-time': 'Open Time',
    'success-order-column-memo': 'Memo',
    'income-range-start-placeholder': 'Open Time',
    'income-range-end-placeholder': 'Close Time',
    'income-summary-total-pl': 'Total Copy P&L:',
    'income-summary-total-subfee': 'Total Subscription Fee:',
    'income-summary-real-profit': 'Net Profit:',
    'income-summary-total-volume': 'Total Volume:',
    'income-column-signal-name': 'Signal Name',
    'income-column-account': 'Copy Account',
    'income-column-ticket': 'Order ID',
    'income-column-symbol': 'Symbol',
    'income-column-direction-volume': 'Direction / Volume',
    'income-column-open-price': 'Open Price',
    'income-column-close-price': 'Close Price',
    'income-column-profit': 'Copy P&L',
    'income-column-open-time': 'Open Time',
    'income-column-close-time': 'Close Time',
    'income-column-memo': 'Memo',
    'share-search-placeholder': 'Search account or signal name',
    'share-range-start-placeholder': 'Payout Start Time',
    'share-range-end-placeholder': 'Payout End Time',
    'share-summary-total-subfee': 'Total Subscription Fee:',
    'share-summary-subfee': 'Subscription Fee:',
    'share-summary-refund-subfee': 'Refunded Subscription Fee:',
    'share-fee-type-subscribe': 'Subscription Fee',
    'share-fee-type-refund': 'Refund',
    'share-column-signal-name': 'Signal Name',
    'share-column-account': 'Copy Account',
    'share-column-fee-id': 'Payout ID',
    'share-column-type': 'Type',
    'share-column-amount': 'Amount',
    'share-column-period': 'Subscription / Settlement Period',
    'share-column-calc-time': 'Payout Time',
    'followIncome-tab-income': 'Income Records',
    'followIncome-tab-share': 'Commission Records',
    'followLog-tab-open': 'Open Logs',
    'followLog-tab-close': 'Close Logs',
    'followLog-tab-fail': 'Failed Logs',
    'position-filter-direction': 'Trade Direction',
    'position-column-signal-name': 'Signal Name',
    'position-column-account': 'Account',
    'position-column-ticket': 'Order ID',
    'position-column-symbol': 'Symbol',
    'position-column-direction-volume': 'Direction / Volume',
    'position-column-open-price': 'Open Price',
    'position-column-open-time': 'Open Time',
    'position-column-memo': 'Memo',
    'position-column-signal-account': 'Account',
    'position-column-signal-ticket': 'Order ID',
    'position-column-signal-symbol': 'Symbol',
    'position-column-signal-direction-volume': 'Direction / Volume',
    'position-column-signal-open-price': 'Open Price',
    'position-column-signal-open-time': 'Open Time',
    'position-column-signal-memo': 'Memo',
    'position-no-field': 'No data',
    'myShare-filter-mode': 'Commission Type',
    'myShare-filter-mode-share': 'Sharer Commission',
    'myShare-filter-mode-invite': 'Invitee Commission',
    'myShare-tag-share': 'Sharer',
    'myShare-tag-invite': 'Referral',
    'myShare-status-pending-settle': 'Pending Settlement',
    'myShare-status-pending-redeem': 'Pending Redemption',
    'myShare-status-subscribing': 'Subscribing',
    'myShare-status-stopped': 'Stopped',
    'myShare-button-detail': 'Details',
    'myShare-column-signal-id': 'Signal ID',
    'myShare-column-signal-name': 'Signal Name',
    'myShare-column-copy-member': 'Follower',
    'myShare-column-type': 'Type',
    'myShare-column-copy-amount': 'Copy Amount',
    'myShare-column-share-amount': 'My Sharer Commission',
    'myShare-column-invite-amount': 'My Referral Commission',
    'myShare-column-status': 'Status',
    'myShare-column-subscribe-time': 'Subscription Time',
    'mySubscribe-filter-direction': 'Copy Direction',
    'mySubscribe-filter-status': 'Status',
    'mySubscribe-direction-forward': 'Forward Copy',
    'mySubscribe-direction-reverse': 'Reverse Copy',
    'mySubscribe-status-running': 'Active',
    'mySubscribe-status-paused': 'Paused',
    'mySubscribe-status-cancelled': 'Cancelled',
    'mySubscribe-fee-type-subscription': 'Subscription Fee',
    'mySubscribe-fee-type-performance': 'Profit Share',
    'mySubscribe-button-edit': 'Edit',
    'mySubscribe-button-complete': 'Supplement',
    'mySubscribe-button-cancel': 'Cancel',
    'mySubscribe-modal-cancel-title': 'Cancel Copy',
    'mySubscribe-modal-desc-performance':
      'After cancelling, the system will automatically close all following orders.',
    'mySubscribe-modal-desc-subscription':
      'After cancelling, new positions from this signal will no longer be copied. Please close existing copy positions manually.',
    'mySubscribe-column-signal-name': 'Signal Name',
    'mySubscribe-column-signal-id': 'Signal ID',
    'mySubscribe-column-account': 'Copy Account',
    'mySubscribe-column-fee-type': 'Pricing Model',
    'mySubscribe-column-direction': 'Copy Direction',
    'mySubscribe-column-multiplier': 'Multiplier',
    'mySubscribe-column-status': 'Status',
    'mySubscribe-column-volume': 'Copy Volume',
    'mySubscribe-column-trade-count': 'Copy Trades',
    'mySubscribe-column-profit': 'Copy Profit',
    'mySubscribe-column-take-profit': 'Take Profit',
    'mySubscribe-column-stop-loss': 'Stop Loss',
    'mySubscribe-column-subscribe-time': 'Subscription Time',
    'mySubscribe-column-expire-time': 'Expiry Time',
    'mySubscribe-column-cancel-time': 'Cancel Time',
    'publishCard-status-investable': 'Investable',
    'publishCard-tooltip-title': 'Please review requirements',
    'publishCard-min-deposit': 'Minimum Deposit',
    'publishCard-signal-equity': 'Signal Equity',
    'publishCard-total-equity': 'Total Equity',
    'publishCard-status-not-investable': 'Not Investable',
    'publishCard-trade-count': 'Trades {current}/{target}',
    'publishCard-trade-tip': 'More than {count} closed trades',
    'publishCard-signal-life': 'Strategy lifespan {current}/{target}',
    'publishCard-signal-life-tip': 'Has exceeded {value} since first trade',
    'publishCard-last-trade': 'Last trade {value}',
    'publishCard-last-trade-tip':
      'Latest trading activity must be within {value} (including weekends)',
    'publishCard-not-showing': 'Not shown in Signal Plaza',
    'publishCard-showing': 'Displayed in Signal Plaza',
    'publishCard-archive-time': 'Archived At :',
    'publishCard-button-deposit': 'Deposit',
    'publishCard-button-trade': 'Trade',
    'publishCard-action-share': 'Share',
    'publishCard-action-report': 'Report',
    'publishCard-action-edit': 'Edit Signal Info',
    'publishCard-action-edit-fee': 'Edit Profit Share',
    'publishCard-action-edit-min': 'Edit Minimum Investment',
    'publishCard-action-withdraw': 'Withdraw',
    'publishCard-action-archive': 'Archive Signal',
    'publishCard-label-id': 'ID',
    'publishCard-signal-principal': 'Signal Principal',
    'publishCard-signal-profit': 'Signal Profit',
    'publishCard-copy-capital': 'Copy Capital',
    'publishCard-copy-profit': 'Copy Profit',
    'publishCard-my-fee': 'My Performance Fee',
    'publishCard-fee-rate': 'Profit Share %',
    'publishCard-copy-count': 'Followers',
    'publishCard-copy-count-tip': 'Current / Total Followers',
    'publishCard-min-copy-amount': 'Minimum Copy Amount',
    'assetsCard-invest-time': 'Invested At',
    'assetsCard-submit-time': 'Submitted At',
    'assetsCard-stop-time': 'Stopped At',
    'assetsCard-invest-id': 'Investment ID',
    'assetsCard-invest-amount': 'Investment Amount',
    'assetsCard-profit': 'P&L',
    'assetsCard-fee': 'Performance Fee',
    'assets-card-total-profit': 'Total Copy Profit',
    'assets-card-net-profit': 'Net Profit',
    'assets-card-total-volume': 'Total Copy Volume',
    'assets-summary-balance': 'Balance',
    'assets-summary-available': 'Available',
    'assets-summary-margin': 'Used Margin',
    'assets-summary-unrealized': 'Floating P&L',
    'assets-tab-position': 'Current Copy',
    'assets-tab-follow-log': 'Copy Log',
    'assets-tab-my-subscribe': 'My Subscription',
    'assets-tab-follow-income': 'Copy Income',
    'assets-tab-my-share': 'My Share / Referral',
    'assets-account-platform': 'Platform Account',
    'assets-account-external': 'External Account',
    'filter-status': 'Status',
    'button-cancel': 'Cancel',
    'no-field': 'N/A',
    'status-pending': 'Pending Review',
    'status-rejected': 'Rejected',
    'time-format-month-short': 'Month',
    'time-format-quarter': 'Quarter',
    'time-format-half-year': 'Half-Year',
    'time-format-year-short': 'Year',
    'createSignals-hero-prefix': 'Become ',
    'createSignals-hero-highlight1': 'a trading expert',
    'createSignals-hero-middle': ', earn ',
    'createSignals-hero-highlight2': 'generous',
    'createSignals-hero-suffix': ' profit share',
    'createSignals-stat1-title': 'Over 1 million copy users',
    'createSignals-stat1-desc': 'Active traders worldwide',
    'createSignals-stat2-title': 'USD 2M paid to trading experts',
    'createSignals-stat2-desc': 'Empowering elite traders',
    'createSignals-stat3-title': 'Massive exposure opportunities',
    'createSignals-stat3-desc': 'Multiple media campaigns',
    'createSignals-heading': 'Publish Signal',
    'createSignals-label-account': 'Signal Account',
    'createSignals-label-name': 'Signal Name',
    'createSignals-placeholder-name': 'Enter signal name',
    'createSignals-placeholder-profit-fee': 'Enter a value 0-100',
    'createSignals-subscription-fee-title': 'Subscription Fee',
    'createSignals-placeholder-amount': 'Enter amount',
    'createSignals-fee-suffix-month': 'USD/month',
    'createSignals-fee-suffix-season': 'USD/quarter',
    'createSignals-fee-suffix-half-year': 'USD/half-year',
    'createSignals-fee-suffix-year': 'USD/year',
    'createSignals-label-photo': 'Signal Photo',
    'createSignals-label-desc': 'Trading Description',
    'createSignals-placeholder-desc': 'Enter trading description',
    'createSignals-share-title': 'Sharer Commission',
    'createSignals-invite-title': 'Invitee Commission',
    'createSignals-optional': ' (Optional)',
    'createSignals-share-placeholder': 'Level {level} sharer commission rate',
    'createSignals-invite-header-level': 'Commission Level',
    'createSignals-invite-header-rate': 'Commission Rate',
    'createSignals-invite-level-label': 'Level {level} Invitee',
    'createSignals-invite-placeholder': 'Level {level} invitee commission rate',
    'createSignals-button-confirm': 'Confirm',
    'createSignals-modal-title': 'Signal Published',
    'createSignals-modal-desc': 'Signal {name} created successfully',
    'createSignals-modal-view': 'View Signal',
    'createSignals-modal-trade': 'Trade',
    'createSignals-error-select-account': 'Please select a signal account',
    'createSignals-error-input-name': 'Please enter a signal name',
    'createSignals-error-name-length': 'Signal name cannot exceed 40 characters',
    'createSignals-error-select-fee-type': 'Please select a pricing model',
    'createSignals-error-input-profit-fee': 'Please enter a value between 0 and 100',
    'createSignals-error-profit-fee-range': 'Profit share must be between 0 and 100',
    'createSignals-error-input-fee': 'Please enter an amount',
    'createSignals-error-select-photo': 'Please select a signal photo',
    'createSignals-error-input-desc': 'Please enter a trading description',
    'createSignals-error-desc-length': 'Trading description cannot exceed 320 characters',
    'createSignals-error-input-share': 'Please enter sharer commission rate',
    'createSignals-error-commission-range': 'Total commission must be between 0 and 100',
    'createSignals-error-input-invite': 'Please enter invitee commission rate',
    'myPublishFollowLog-tab-performance': 'Performance Model',
    'myPublishFollowLog-tab-subscription': 'Subscription Model',
    'myPublishFollowLog-search-placeholder': 'Search signal name, signal account, follow ID',
    'myPublishFollowLog-column-signal-name': 'Signal Name',
    'myPublishFollowLog-column-account': 'Signal Account',
    'myPublishFollowLog-column-copy-id': 'Follow ID',
    'myPublishFollowLog-column-copy-profit': 'Copy P&L',
    'myPublishFollowLog-column-profit-fee': 'Profit Share %',
    'myPublishFollowLog-column-my-fee': 'My Profit Share',
    'myPublishFollowLog-column-share-fee': 'Sharer Share',
    'myPublishFollowLog-column-invite-fee': 'Invite Share',
    'myPublishFollowLog-column-status': 'Status',
    'myPublishFollowLog-column-subscribe-time': 'Subscribe Time',
    'myPublishFollowLog-column-cancel-time': 'Cancel Time',
    'myPublishFollowLog-column-total-subfee': 'Total Subscription Fee',
    'myPublishFollowLog-column-subscribe-period': 'Subscription Period',
    'myPublishFollowLog-column-distributed': 'Distributed Amount',
    'myPublishFollowLog-column-frozen': 'Frozen Amount',
    'myPublishFollowLog-column-my-income': 'My Income',
    'myPublishFollowLog-column-share-income': 'Sharer Income',
    'myPublishFollowLog-column-invite-income': 'Invitee Income',
    'myPublishFollowLog-column-expire-time': 'Expiry Time',
    'myPublishShareLog-tab-performance': 'Performance Model',
    'myPublishShareLog-tab-subscription': 'Subscription Model',
    'myPublishShareLog-search-placeholder': 'Search signal name, signal account, follow ID',
    'myPublishShareLog-column-signal-name': 'Signal Name',
    'myPublishShareLog-column-account': 'Signal Account',
    'myPublishShareLog-column-copy-id': 'Follow ID',
    'myPublishShareLog-column-total-subfee': 'Total Subscription Fee',
    'myPublishShareLog-column-profit-fee': 'Profit Share %',
    'myPublishShareLog-column-my-fee': 'My Profit Share',
    'myPublishShareLog-column-share-fee': 'Sharer Share',
    'myPublishShareLog-column-invite-fee': 'Invite Share',
    'myPublishShareLog-column-status': 'Status',
    'myPublishShareLog-column-subscribe-time': 'Subscribe Time',
    'myPublishShareLog-column-cancel-time': 'Cancel Time',
    'myPublishShareLog-column-order-id': 'Order ID',
    'myPublishShareLog-column-follow-id': 'Follow ID',
    'myPublishShareLog-column-subscribe-period': 'Subscription Period',
    'myPublishShareLog-column-distributed': 'Distributed Amount',
    'myPublishShareLog-column-frozen': 'Frozen Amount',
    'myPublishShareLog-column-refund': 'Refund Amount',
    'myPublishShareLog-column-my-income': 'My Income',
    'myPublishShareLog-column-share-income': 'Sharer Income',
    'myPublishShareLog-column-invite-income': 'Invitee Income',
    'myPublishShareLog-column-settle-time': 'Settlement Time',
    'myPublishShareLog-share-detail': 'Level {level}',
    'myPublishShareLog-invite-line': 'Level {level} {rate}% / {amount} USD',
    'myPublishPublishLog-tab-performance': 'Performance Model',
    'myPublishPublishLog-tab-subscription': 'Subscription Model',
    'myPublishPublishLog-search-placeholder': 'Search signal name or account',
    'myPublishPublishLog-column-signal-name': 'Signal Name',
    'myPublishPublishLog-column-account': 'Signal Account',
    'myPublishPublishLog-column-followers': 'Followers',
    'myPublishPublishLog-followers-tip': 'Current / Total Followers',
    'myPublishPublishLog-column-fee': 'Fee Structure',
    'myPublishPublishLog-column-total-subfee': 'Total Subscription Fee',
    'myPublishPublishLog-column-distributed': 'Distributed Amount',
    'myPublishPublishLog-column-frozen': 'Frozen Amount',
    'myPublishPublishLog-column-my-income': 'My Income',
    'myPublishPublishLog-column-status': 'Status',
    'myPublishPublishLog-column-share-income': 'Sharer Income',
    'myPublishPublishLog-column-invite-income': 'Invitee Income',
    'myPublishPublishLog-column-created-at': 'Published At',
    'myPublishPublishLog-column-closed-at': 'Cancelled At',
    'myPublishPublishLog-column-order-id': 'Order ID',
    'myPublishPublishLog-column-follow-id': 'Follow ID',
    'myPublishPublishLog-column-refund': 'Refund Amount',
    'myPublishPublishLog-column-subscribe-period': 'Subscription Period',
    'myPublishPublishLog-column-settle-time': 'Settlement Time',
    'myPublishPublishLog-fee-start': 'from',
    'myPublish-card-total-subfee': 'Total Subscription Fee',
    'myPublish-card-my-income': 'My Income',
    'myPublish-card-frozen-income': 'Frozen Income',
    'myPublish-summary-subscription': 'Subscription Summary',
    'myPublish-summary-sub-income': 'Subscription Income',
    'myPublish-summary-frozen-income': 'Frozen Income',
    'myPublish-summary-share-income': 'Sharer Income',
    'myPublish-summary-invite-income': 'Invitee Income',
    'myPublish-button-create': 'Create Signal',
    'myPublish-tab-publish': 'My Publications',
    'myPublish-tab-follow': 'Followers',
    'myPublish-tab-share': 'My Profit Share',
    'signalDetails-earning-rate': 'Return Rate',
    'signalDetails-total-profit': 'Total P&L',
    'signalDetails-max-drawdown': 'Max Drawdown',
    'signalDetails-follow-now': 'Copy Now',
    'signalDetails-stop-copy': 'Stop Copying',
    'signalDetails-share': 'Share',
    'signalDetails-tab-overview': 'Overview',
    'signalDetails-tab-order': 'Orders',
    'signalOrder-summary-total-pl': 'Total P&L:',
    'signalOrder-summary-order-pl': 'Order P&L:',
    'signalOrder-summary-interest': 'Interest:',
    'signalOrder-summary-commission': 'Commission:',
    'signalOrder-tab-open': 'Open Positions',
    'signalOrder-tab-close': 'Closed Positions',
    'signalOrder-column-symbol-info': 'Symbol Info',
    'signalOrder-column-avg-open-price': 'Open Price',
    'signalOrder-column-profit': 'Profit',
    'signalOrder-column-symbol': 'Symbol',
    'signalOrder-column-ticket': 'Order ID',
    'signalOrder-column-direction-volume': 'Direction / Volume',
    'signalOrder-column-open-price': 'Open Price',
    'signalOrder-column-close-price': 'Close Price',
    'signalOrder-column-tp': 'Take Profit',
    'signalOrder-column-sl': 'Stop Loss',
    'signalOrder-column-interest': 'Interest',
    'signalOrder-column-commission': 'Commission',
    'signalOrder-column-open-time': 'Open Time',
    'signalOrder-column-close-time': 'Close Time',
    'signalOrder-column-entry': 'Trend',
    'signalOrder-expand-open-price': 'Open Price',
    'signalOrder-expand-interest': 'Swap',
    'signalOrder-expand-open-time': 'Open Time',
    'signalOrder-expand-volume': 'Volume',
    'signalOrder-expand-commission': 'Commission',
    'signalOrder-expand-profit': 'Profit',
    'signalOverview-section-intro': 'Strategy Introduction',
    'signalOverview-section-summary': 'Overview',
    'signalOverview-summary-equity': 'Net Equity',
    'signalOverview-summary-follow-profit': 'Copy P&L',
    'signalOverview-summary-leverage': 'Leverage',
    'signalOverview-summary-total-trades': 'Total Trades',
    'signalOverview-summary-join-days': 'Joined (days)',
    'signalOverview-summary-trade-frequency': 'Trades / Day',
    'signalOverview-summary-subscription-fee': 'Subscription Fee',
    'signalOverview-fee-start': 'from',
    'signalOverview-section-trade-stats': 'Trading Breakdown',
    'signalOverview-section-profit-analysis': 'Profit Analysis',
    'signalOverview-section-trade-volume': 'Trading Volume',
    'signalOverview-section-trade-volume-unit': '(Million USD)',
    'signalOverview-tab-profit-rate': 'Return Rate',
    'signalOverview-tab-total-profit': 'Total Profit',
    'signalOverview-range-7days': '7 Days',
    'signalOverview-range-14days': '14 Days',
    'signalOverview-range-30days': '30 Days',
    'shareDetails-signal-id': 'Signal ID:',
    'shareDetails-follower': 'Follower',
    'shareDetails-share-rate': 'Sharer Commission',
    'shareDetails-invite-rate': 'Invitee Commission',
    'shareDetails-total-equity': 'Copy Capital',
    'shareDetails-share-amount': 'Sharer Payout',
    'shareDetails-invite-amount': 'Invitee Payout',
    'shareDetails-column-settle-period': 'Settlement Period',
    'shareDetails-column-share-fee': 'Sharer Payout',
    'shareDetails-column-invite-fee': 'Invitee Payout',
    'shareDetails-column-settle-time': 'Settlement Time',
    'startCopy-no-desc': 'No introduction available',
    'startCopy-earning-rate': 'Return Rate',
    'startCopy-total-profit': 'Total P&L',
    'startCopy-follow-profit': 'Copy Returns',
    'startCopy-max-drawdown': 'Max Drawdown',
    'startCopy-fee-label-subscription': 'Subscription Fee',
    'startCopy-fee-label-performance': 'Profit Share',
    'startCopy-fee-start': 'from',
    'startCopy-leverage': 'Leverage',
    'startCopy-section-copy-account': 'Copy Account',
    'startCopy-account-balance': 'Balance',
    'startCopy-account-available': 'Available',
    'startCopy-account-margin': 'Margin Used',
    'startCopy-account-unrealized': 'Floating P&L',
    'startCopy-account-type-platform': 'Platform Account',
    'startCopy-symbol-section-title': 'Symbol',
    'startCopy-symbol-select-all': 'All',
    'startCopy-symbol-placeholder': 'Enter symbol',
    'startCopy-duration-title': 'Subscription Duration',
    'startCopy-follow-info-title': 'Copy Settings',
    'startCopy-direction-forward': 'Forward Copy',
    'startCopy-direction-reverse': 'Reverse Copy',
    'startCopy-follow-times-suffix': 'x',
    'startCopy-follow-times-placeholder': 'Enter multiplier',
    'startCopy-follow-times-tip':
      'Minimum copy multiplier 0.01 (1.00%). If it is below the minimum trade size, the minimum trade size will be used.',
    'startCopy-sltp-title': 'Take Profit / Stop Loss',
    'startCopy-optional': ' (Optional)',
    'startCopy-stop-loss-placeholder': 'Amount Stop Loss',
    'startCopy-take-profit-placeholder': 'Amount Take Profit',
    'startCopy-match-rules-title': 'Matching Rules',
    'startCopy-table-index': '#',
    'startCopy-table-signal-suffix': 'Signal Suffix',
    'startCopy-table-signal-symbol': 'Signal Symbol',
    'startCopy-table-my-suffix': 'Copy Suffix',
    'startCopy-table-my-symbol': 'Copy Symbol',
    'startCopy-placeholder-signal-suffix': 'Select signal suffix',
    'startCopy-placeholder-my-suffix': 'Select copy suffix',
    'startCopy-placeholder-signal-symbol': 'Select signal symbol',
    'startCopy-placeholder-my-symbol': 'Select copy symbol',
    'startCopy-no-suffix': 'No suffix',
    'startCopy-agreement-prefix':
      'By clicking "Confirm", I acknowledge that I have read, understood, and agree to the ',
    'startCopy-agreement-link': 'Copy Trading Service Agreement',
    'startCopy-agreement-suffix': '.',
    'startCopy-button-confirm': 'Confirm',
    'startCopy-validate-follow-times': 'Please enter copy multiplier',
    'startCopy-validate-agreement': 'Please accept the agreement',
    'startCopy-tab-suffix': 'Suffix Mapping',
    'startCopy-tab-symbol': 'Symbol Mapping',
    'startCopy-notify-password-title': 'Enter Password',
    'startCopy-notify-password-desc': 'Please enter a valid funding password',
    'main-no-account': 'No live account available',
    'main-account-balance': 'Balance',
    'main-account-available': 'Available',
    'main-account-margin': 'Margin Used',
    'main-account-unrealized': 'Floating P&L',
    'main-account-type-platform': 'Platform Account',
    'main-button-my-assets': 'My Copy Trades',
    'main-button-become-expert': 'Become a Trading Expert',
    'main-button-my-publish': 'My Publications',
    'main-heading-signal-plaza': 'Signal Plaza',
    'main-search-placeholder': 'Search',
    'main-tab-all': 'All',
    'main-tab-recommend': 'Recommended',
    'main-tab-earning': 'Top Returns',
    'main-tab-drawdown': 'Lowest Drawdown',
    'main-tab-fee': 'Lowest Subscription Fee',
    'main-column-signal-name': 'Signal Name',
    'main-column-signal-id': 'Signal ID',
    'main-column-fee': 'Pricing Model / Fee',
    'main-column-max-drawdown': 'Max Drawdown',
    'main-column-earning-rate': 'Return Rate',
    'main-column-total-profit': 'Total P&L',
    'main-column-follow-profit': 'Copy Returns',
    'main-column-create-time': 'Published At',
    'main-tag-subscription': 'Subscription Fee',
    'main-tag-profit-share': 'Profit Share',
    'status-running': 'Running',
    'status-paused': 'Paused',
    'status-stopped': 'Stopped',
    'status-cancelled': 'Cancelled',
    'status-completed': 'Completed',
    'status-failed': 'Failed',
    'status-pending-settle': 'Pending Settlement',
    'status-pending-redeem': 'Pending Redemption',
    'time-format-day': ' days',
    'time-format-hour': ' hours',
    'time-format-minute': ' minutes',
    'time-format-second': ' seconds',
    'editInfo-title': 'Edit Signal Info',
    'editInfo-label-name': 'Signal Name',
    'editInfo-placeholder-name': 'Enter signal name',
    'editInfo-label-description': 'Signal Description',
    'editInfo-placeholder-description': 'Enter signal description',
    'editInfo-label-photo': 'Signal Photo',
    'editInfo-validate-name': 'Please enter signal name',
    'editInfo-validate-description': 'Please enter signal description',
    'editInfo-validate-photo': 'Please select a signal photo',
    'editInfo-notify-success': 'Signal info updated successfully',
    'editInfo-notify-fail': 'Failed to update signal info',
  },
  outCopy: {
    'search-order-placeholder': 'Search order ID, symbol, account, signal name',
    'filter-direction-placeholder': 'Trade Direction',
    'direction-buy': 'Buy',
    'direction-sell': 'Sell',
    'direction-buy-short': 'Buy',
    'direction-sell-short': 'Sell',
    'button-confirm': 'Confirm',
    'button-reset': 'Reset',
    'tag-copy': 'Copy',
    'tag-signal': 'Signal',
    'unit-lot': 'lots',
    'toggle-collapse': 'Collapse',
    'toggle-expand': 'Expand',
    'close-order-column-signal-name': 'Signal Name',
    'close-order-column-account': 'Account',
    'close-order-column-ticket': 'Order ID',
    'close-order-column-symbol': 'Symbol',
    'close-order-column-direction-volume': 'Direction / Volume',
    'close-order-column-open-price': 'Open Price',
    'close-order-column-close-price': 'Close Price',
    'close-order-column-profit': 'Copy Returns',
    'close-order-column-open-time': 'Open Time',
    'close-order-column-close-time': 'Close Time',
    'close-order-column-memo': 'Memo',
    'fail-order-column-signal-name': 'Signal Name',
    'fail-order-column-account': 'Account',
    'fail-order-column-ticket': 'Order ID',
    'fail-order-column-symbol': 'Symbol',
    'fail-order-column-direction-volume': 'Direction / Volume',
    'fail-order-column-operation': 'Operation',
    'fail-order-column-request-volume': 'Requested Volume',
    'fail-order-column-real-volume': 'Executed Volume',
    'fail-order-column-time': 'Time',
    'fail-order-column-memo': 'Memo',
    'operation-open': 'Open',
    'operation-close': 'Close',
    'success-order-column-signal-name': 'Signal Name',
    'success-order-column-account': 'Account',
    'success-order-column-ticket': 'Order ID',
    'success-order-column-symbol': 'Symbol',
    'success-order-column-direction-volume': 'Direction / Volume',
    'success-order-column-open-price': 'Open Price',
    'success-order-column-open-time': 'Open Time',
    'success-order-column-memo': 'Memo',
    'income-range-start-placeholder': 'Open Time',
    'income-range-end-placeholder': 'Close Time',
    'income-summary-total-pl': 'Total Copy P&L:',
    'income-summary-total-subfee': 'Total Subscription Fee:',
    'income-summary-real-profit': 'Net Profit:',
    'income-summary-total-volume': 'Total Volume:',
    'income-column-signal-name': 'Signal Name',
    'income-column-account': 'Copy Account',
    'income-column-ticket': 'Order ID',
    'income-column-symbol': 'Symbol',
    'income-column-direction-volume': 'Direction / Volume',
    'income-column-open-price': 'Open Price',
    'income-column-close-price': 'Close Price',
    'income-column-profit': 'Copy P&L',
    'income-column-open-time': 'Open Time',
    'income-column-close-time': 'Close Time',
    'income-column-memo': 'Memo',
    'share-search-placeholder': 'Search account or signal name',
    'share-range-start-placeholder': 'Payout Start Time',
    'share-range-end-placeholder': 'Payout End Time',
    'share-summary-total-subfee': 'Total Subscription Fee:',
    'share-summary-subfee': 'Subscription Fee:',
    'share-summary-refund-subfee': 'Refunded Subscription Fee:',
    'share-fee-type-subscribe': 'Subscription Fee',
    'share-fee-type-refund': 'Refund',
    'share-column-signal-name': 'Signal Name',
    'share-column-account': 'Copy Account',
    'share-column-fee-id': 'Payout ID',
    'share-column-type': 'Type',
    'share-column-amount': 'Amount',
    'share-column-period': 'Subscription / Settlement Period',
    'share-column-calc-time': 'Payout Time',
    'followIncome-tab-income': 'Income Records',
    'followIncome-tab-share': 'Commission Records',
    'followLog-tab-open': 'Open Logs',
    'followLog-tab-close': 'Close Logs',
    'followLog-tab-fail': 'Failed Logs',
    'position-filter-direction': 'Trade Direction',
    'position-column-signal-name': 'Signal Name',
    'position-column-account': 'Account',
    'position-column-ticket': 'Order ID',
    'position-column-symbol': 'Symbol',
    'position-column-direction-volume': 'Direction / Volume',
    'position-column-open-price': 'Open Price',
    'position-column-open-time': 'Open Time',
    'position-column-memo': 'Memo',
    'position-column-signal-account': 'Account',
    'position-column-signal-ticket': 'Order ID',
    'position-column-signal-symbol': 'Symbol',
    'position-column-signal-direction-volume': 'Direction / Volume',
    'position-column-signal-open-price': 'Open Price',
    'position-column-signal-open-time': 'Open Time',
    'position-column-signal-memo': 'Memo',
    'position-no-field': 'No data',
    'myShare-filter-mode': 'Commission Type',
    'myShare-filter-mode-share': 'Sharer Commission',
    'myShare-filter-mode-invite': 'Invitee Commission',
    'myShare-tag-share': 'Sharer',
    'myShare-tag-invite': 'Referral',
    'myShare-status-pending-settle': 'Pending Settlement',
    'myShare-status-pending-redeem': 'Pending Redemption',
    'myShare-status-subscribing': 'Subscribing',
    'myShare-status-stopped': 'Stopped',
    'myShare-button-detail': 'Details',
    'myShare-column-signal-id': 'Signal ID',
    'myShare-column-signal-name': 'Signal Name',
    'myShare-column-copy-member': 'Follower',
    'myShare-column-type': 'Type',
    'myShare-column-copy-amount': 'Copy Amount',
    'myShare-column-share-amount': 'My Sharer Commission',
    'myShare-column-invite-amount': 'My Referral Commission',
    'myShare-column-status': 'Status',
    'myShare-column-subscribe-time': 'Subscription Time',
    'mySubscribe-filter-direction': 'Copy Direction',
    'mySubscribe-filter-status': 'Status',
    'mySubscribe-direction-forward': 'Forward Copy',
    'mySubscribe-direction-reverse': 'Reverse Copy',
    'mySubscribe-status-running': 'Active',
    'mySubscribe-status-paused': 'Paused',
    'mySubscribe-status-cancelled': 'Cancelled',
    'mySubscribe-fee-type-subscription': 'Subscription Fee',
    'mySubscribe-fee-type-performance': 'Profit Share',
    'mySubscribe-button-edit': 'Edit',
    'mySubscribe-button-complete': 'Supplement',
    'mySubscribe-button-cancel': 'Cancel',
    'mySubscribe-modal-cancel-title': 'Cancel Copy',
    'mySubscribe-modal-desc-performance':
      'After cancelling, the system will automatically close all following orders.',
    'mySubscribe-modal-desc-subscription':
      'After cancelling, new positions from this signal will no longer be copied. Please close existing copy positions manually.',
    'mySubscribe-column-signal-name': 'Signal Name',
    'mySubscribe-column-signal-id': 'Signal ID',
    'mySubscribe-column-account': 'Copy Account',
    'mySubscribe-column-fee-type': 'Pricing Model',
    'mySubscribe-column-direction': 'Copy Direction',
    'mySubscribe-column-multiplier': 'Multiplier',
    'mySubscribe-column-status': 'Status',
    'mySubscribe-column-volume': 'Copy Volume',
    'mySubscribe-column-trade-count': 'Copy Trades',
    'mySubscribe-column-profit': 'Copy Profit',
    'mySubscribe-column-take-profit': 'Take Profit',
    'mySubscribe-column-stop-loss': 'Stop Loss',
    'mySubscribe-column-subscribe-time': 'Subscription Time',
    'mySubscribe-column-expire-time': 'Expiry Time',
    'mySubscribe-column-cancel-time': 'Cancel Time',
    'publishCard-status-investable': 'Investable',
    'publishCard-tooltip-title': 'Please review requirements',
    'publishCard-min-deposit': 'Minimum Deposit',
    'publishCard-signal-equity': 'Signal Equity',
    'publishCard-total-equity': 'Total Equity',
    'publishCard-status-not-investable': 'Not Investable',
    'publishCard-trade-count': 'Trades {current}/{target}',
    'publishCard-trade-tip': 'More than {count} closed trades',
    'publishCard-signal-life': 'Strategy lifespan {current}/{target}',
    'publishCard-signal-life-tip': 'Has exceeded {value} since first trade',
    'publishCard-last-trade': 'Last trade {value}',
    'publishCard-last-trade-tip':
      'Latest trading activity must be within {value} (including weekends)',
    'publishCard-not-showing': 'Not shown in Signal Plaza',
    'publishCard-showing': 'Displayed in Signal Plaza',
    'publishCard-archive-time': 'Archived At :',
    'publishCard-button-deposit': 'Deposit',
    'publishCard-button-trade': 'Trade',
    'publishCard-action-share': 'Share',
    'publishCard-action-report': 'Report',
    'publishCard-action-edit': 'Edit Signal Info',
    'publishCard-action-edit-fee': 'Edit Profit Share',
    'publishCard-action-edit-min': 'Edit Minimum Investment',
    'publishCard-action-withdraw': 'Withdraw',
    'publishCard-action-archive': 'Archive Signal',
    'publishCard-label-id': 'ID',
    'publishCard-signal-principal': 'Signal Principal',
    'publishCard-signal-profit': 'Signal Profit',
    'publishCard-copy-capital': 'Copy Capital',
    'publishCard-copy-profit': 'Copy Profit',
    'publishCard-my-fee': 'My Performance Fee',
    'publishCard-fee-rate': 'Profit Share %',
    'publishCard-copy-count': 'Followers',
    'publishCard-copy-count-tip': 'Current / Total Followers',
    'publishCard-min-copy-amount': 'Minimum Copy Amount',
    'assetsCard-invest-time': 'Invested At',
    'assetsCard-submit-time': 'Submitted At',
    'assetsCard-stop-time': 'Stopped At',
    'assetsCard-invest-id': 'Investment ID',
    'assetsCard-invest-amount': 'Investment Amount',
    'assetsCard-profit': 'P&L',
    'assetsCard-fee': 'Performance Fee',
    'assets-card-total-profit': 'Total Copy Profit',
    'assets-card-net-profit': 'Net Profit',
    'assets-card-total-volume': 'Total Copy Volume',
    'assets-summary-balance': 'Balance',
    'assets-summary-available': 'Available',
    'assets-summary-margin': 'Used Margin',
    'assets-summary-unrealized': 'Floating P&L',
    'assets-tab-position': 'Current Copy',
    'assets-tab-follow-log': 'Copy Log',
    'assets-tab-my-subscribe': 'My Subscription',
    'assets-tab-follow-income': 'Copy Income',
    'assets-tab-my-share': 'My Share / Referral',
    'assets-account-platform': 'Platform Account',
    'assets-account-external': 'External Account',
    'filter-status': 'Status',
    'button-cancel': 'Cancel',
    'no-field': 'N/A',
    'status-pending': 'Pending Review',
    'status-rejected': 'Rejected',
    'time-format-month-short': 'Month',
    'time-format-quarter': 'Quarter',
    'time-format-half-year': 'Half-Year',
    'time-format-year-short': 'Year',
    'createSignals-hero-prefix': 'Become ',
    'createSignals-hero-highlight1': 'a trading expert',
    'createSignals-hero-middle': ', earn ',
    'createSignals-hero-highlight2': 'generous',
    'createSignals-hero-suffix': ' profit share',
    'createSignals-stat1-title': 'Over 1 million copy users',
    'createSignals-stat1-desc': 'Active traders worldwide',
    'createSignals-stat2-title': 'USD 2M paid to trading experts',
    'createSignals-stat2-desc': 'Empowering elite traders',
    'createSignals-stat3-title': 'Massive exposure opportunities',
    'createSignals-stat3-desc': 'Multiple media campaigns',
    'createSignals-heading': 'Publish Signal',
    'createSignals-label-account': 'Signal Account',
    'createSignals-label-name': 'Signal Name',
    'createSignals-placeholder-name': 'Enter signal name',
    'createSignals-placeholder-profit-fee': 'Enter a value 0-100',
    'createSignals-subscription-fee-title': 'Subscription Fee',
    'createSignals-placeholder-amount': 'Enter amount',
    'createSignals-fee-suffix-month': 'USD/month',
    'createSignals-fee-suffix-season': 'USD/quarter',
    'createSignals-fee-suffix-half-year': 'USD/half-year',
    'createSignals-fee-suffix-year': 'USD/year',
    'createSignals-label-photo': 'Signal Photo',
    'createSignals-label-desc': 'Trading Description',
    'createSignals-placeholder-desc': 'Enter trading description',
    'createSignals-share-title': 'Sharer Commission',
    'createSignals-invite-title': 'Invitee Commission',
    'createSignals-optional': ' (Optional)',
    'createSignals-share-placeholder': 'Level {level} sharer commission rate',
    'createSignals-invite-header-level': 'Commission Level',
    'createSignals-invite-header-rate': 'Commission Rate',
    'createSignals-invite-level-label': 'Level {level} Invitee',
    'createSignals-invite-placeholder': 'Level {level} invitee commission rate',
    'createSignals-button-confirm': 'Confirm',
    'createSignals-modal-title': 'Signal Published',
    'createSignals-modal-desc': 'Signal {name} created successfully',
    'createSignals-modal-view': 'View Signal',
    'createSignals-modal-trade': 'Trade',
    'createSignals-error-select-account': 'Please select a signal account',
    'createSignals-error-input-name': 'Please enter a signal name',
    'createSignals-error-name-length': 'Signal name cannot exceed 40 characters',
    'createSignals-error-select-fee-type': 'Please select a pricing model',
    'createSignals-error-input-profit-fee': 'Please enter a value between 0 and 100',
    'createSignals-error-profit-fee-range': 'Profit share must be between 0 and 100',
    'createSignals-error-input-fee': 'Please enter an amount',
    'createSignals-error-select-photo': 'Please select a signal photo',
    'createSignals-error-input-desc': 'Please enter a trading description',
    'createSignals-error-desc-length': 'Trading description cannot exceed 320 characters',
    'createSignals-error-input-share': 'Please enter sharer commission rate',
    'createSignals-error-commission-range': 'Total commission must be between 0 and 100',
    'createSignals-error-input-invite': 'Please enter invitee commission rate',
    'myPublishFollowLog-tab-performance': 'Performance Model',
    'myPublishFollowLog-tab-subscription': 'Subscription Model',
    'myPublishFollowLog-search-placeholder': 'Search signal name, signal account, follow ID',
    'myPublishFollowLog-column-signal-name': 'Signal Name',
    'myPublishFollowLog-column-account': 'Signal Account',
    'myPublishFollowLog-column-copy-id': 'Follow ID',
    'myPublishFollowLog-column-copy-profit': 'Copy P&L',
    'myPublishFollowLog-column-profit-fee': 'Profit Share %',
    'myPublishFollowLog-column-my-fee': 'My Profit Share',
    'myPublishFollowLog-column-share-fee': 'Sharer Share',
    'myPublishFollowLog-column-invite-fee': 'Invite Share',
    'myPublishFollowLog-column-status': 'Status',
    'myPublishFollowLog-column-subscribe-time': 'Subscribe Time',
    'myPublishFollowLog-column-cancel-time': 'Cancel Time',
    'myPublishFollowLog-column-total-subfee': 'Total Subscription Fee',
    'myPublishFollowLog-column-subscribe-period': 'Subscription Period',
    'myPublishFollowLog-column-distributed': 'Distributed Amount',
    'myPublishFollowLog-column-frozen': 'Frozen Amount',
    'myPublishFollowLog-column-my-income': 'My Income',
    'myPublishFollowLog-column-share-income': 'Sharer Income',
    'myPublishFollowLog-column-invite-income': 'Invitee Income',
    'myPublishFollowLog-column-expire-time': 'Expiry Time',
    'myPublishShareLog-tab-performance': 'Performance Model',
    'myPublishShareLog-tab-subscription': 'Subscription Model',
    'myPublishShareLog-search-placeholder': 'Search signal name, signal account, follow ID',
    'myPublishShareLog-column-signal-name': 'Signal Name',
    'myPublishShareLog-column-account': 'Signal Account',
    'myPublishShareLog-column-copy-id': 'Follow ID',
    'myPublishShareLog-column-total-subfee': 'Total Subscription Fee',
    'myPublishShareLog-column-profit-fee': 'Profit Share %',
    'myPublishShareLog-column-my-fee': 'My Profit Share',
    'myPublishShareLog-column-share-fee': 'Sharer Share',
    'myPublishShareLog-column-invite-fee': 'Invite Share',
    'myPublishShareLog-column-status': 'Status',
    'myPublishShareLog-column-subscribe-time': 'Subscribe Time',
    'myPublishShareLog-column-cancel-time': 'Cancel Time',
    'myPublishShareLog-column-order-id': 'Order ID',
    'myPublishShareLog-column-follow-id': 'Follow ID',
    'myPublishShareLog-column-subscribe-period': 'Subscription Period',
    'myPublishShareLog-column-distributed': 'Distributed Amount',
    'myPublishShareLog-column-frozen': 'Frozen Amount',
    'myPublishShareLog-column-refund': 'Refund Amount',
    'myPublishShareLog-column-my-income': 'My Income',
    'myPublishShareLog-column-share-income': 'Sharer Income',
    'myPublishShareLog-column-invite-income': 'Invitee Income',
    'myPublishShareLog-column-settle-time': 'Settlement Time',
    'myPublishShareLog-share-detail': 'Level {level}',
    'myPublishShareLog-invite-line': 'Level {level} {rate}% / {amount} USD',
    'myPublishPublishLog-tab-performance': 'Performance Model',
    'myPublishPublishLog-tab-subscription': 'Subscription Model',
    'myPublishPublishLog-search-placeholder': 'Search signal name or account',
    'myPublishPublishLog-column-signal-name': 'Signal Name',
    'myPublishPublishLog-column-account': 'Signal Account',
    'myPublishPublishLog-column-followers': 'Followers',
    'myPublishPublishLog-followers-tip': 'Current / Total Followers',
    'myPublishPublishLog-column-fee': 'Fee Structure',
    'myPublishPublishLog-column-total-subfee': 'Total Subscription Fee',
    'myPublishPublishLog-column-distributed': 'Distributed Amount',
    'myPublishPublishLog-column-frozen': 'Frozen Amount',
    'myPublishPublishLog-column-my-income': 'My Income',
    'myPublishPublishLog-column-status': 'Status',
    'myPublishPublishLog-column-share-income': 'Sharer Income',
    'myPublishPublishLog-column-invite-income': 'Invitee Income',
    'myPublishPublishLog-column-created-at': 'Published At',
    'myPublishPublishLog-column-closed-at': 'Cancelled At',
    'myPublishPublishLog-column-order-id': 'Order ID',
    'myPublishPublishLog-column-follow-id': 'Follow ID',
    'myPublishPublishLog-column-refund': 'Refund Amount',
    'myPublishPublishLog-column-subscribe-period': 'Subscription Period',
    'myPublishPublishLog-column-settle-time': 'Settlement Time',
    'myPublishPublishLog-fee-start': 'from',
    'myPublish-card-total-subfee': 'Total Subscription Fee',
    'myPublish-card-my-income': 'My Income',
    'myPublish-card-frozen-income': 'Frozen Income',
    'myPublish-summary-subscription': 'Subscription Summary',
    'myPublish-summary-sub-income': 'Subscription Income',
    'myPublish-summary-frozen-income': 'Frozen Income',
    'myPublish-summary-share-income': 'Sharer Income',
    'myPublish-summary-invite-income': 'Invitee Income',
    'myPublish-button-create': 'Create Signal',
    'myPublish-tab-publish': 'My Publications',
    'myPublish-tab-follow': 'Followers',
    'myPublish-tab-share': 'My Profit Share',
    'signalDetails-earning-rate': 'Return Rate',
    'signalDetails-total-profit': 'Total P&L',
    'signalDetails-max-drawdown': 'Max Drawdown',
    'signalDetails-follow-now': 'Copy Now',
    'signalDetails-stop-copy': 'Stop Copying',
    'signalDetails-share': 'Share',
    'signalDetails-tab-overview': 'Overview',
    'signalDetails-tab-order': 'Orders',
    'signalOrder-summary-total-pl': 'Total P&L:',
    'signalOrder-summary-order-pl': 'Order P&L:',
    'signalOrder-summary-interest': 'Interest:',
    'signalOrder-summary-commission': 'Commission:',
    'signalOrder-tab-open': 'Open Positions',
    'signalOrder-tab-close': 'Closed Positions',
    'signalOrder-column-symbol-info': 'Symbol Info',
    'signalOrder-column-avg-open-price': 'Open Price',
    'signalOrder-column-profit': 'Profit',
    'signalOrder-column-symbol': 'Symbol',
    'signalOrder-column-ticket': 'Order ID',
    'signalOrder-column-direction-volume': 'Direction / Volume',
    'signalOrder-column-open-price': 'Open Price',
    'signalOrder-column-close-price': 'Close Price',
    'signalOrder-column-tp': 'Take Profit',
    'signalOrder-column-sl': 'Stop Loss',
    'signalOrder-column-interest': 'Interest',
    'signalOrder-column-commission': 'Commission',
    'signalOrder-column-open-time': 'Open Time',
    'signalOrder-column-close-time': 'Close Time',
    'signalOrder-column-entry': 'Trend',
    'signalOrder-expand-open-price': 'Open Price',
    'signalOrder-expand-interest': 'Swap',
    'signalOrder-expand-open-time': 'Open Time',
    'signalOrder-expand-volume': 'Volume',
    'signalOrder-expand-commission': 'Commission',
    'signalOrder-expand-profit': 'Profit',
    'signalOverview-section-intro': 'Strategy Introduction',
    'signalOverview-section-summary': 'Overview',
    'signalOverview-summary-equity': 'Net Equity',
    'signalOverview-summary-follow-profit': 'Copy P&L',
    'signalOverview-summary-leverage': 'Leverage',
    'signalOverview-summary-total-trades': 'Total Trades',
    'signalOverview-summary-join-days': 'Joined (days)',
    'signalOverview-summary-trade-frequency': 'Trades / Day',
    'signalOverview-summary-subscription-fee': 'Subscription Fee',
    'signalOverview-fee-start': 'from',
    'signalOverview-section-trade-stats': 'Trading Breakdown',
    'signalOverview-section-profit-analysis': 'Profit Analysis',
    'signalOverview-section-trade-volume': 'Trading Volume',
    'signalOverview-section-trade-volume-unit': '(Million USD)',
    'signalOverview-tab-profit-rate': 'Return Rate',
    'signalOverview-tab-total-profit': 'Total Profit',
    'signalOverview-range-7days': '7 Days',
    'signalOverview-range-14days': '14 Days',
    'signalOverview-range-30days': '30 Days',
    'shareDetails-signal-id': 'Signal ID:',
    'shareDetails-follower': 'Follower',
    'shareDetails-share-rate': 'Sharer Commission',
    'shareDetails-invite-rate': 'Invitee Commission',
    'shareDetails-total-equity': 'Copy Capital',
    'shareDetails-share-amount': 'Sharer Payout',
    'shareDetails-invite-amount': 'Invitee Payout',
    'shareDetails-column-settle-period': 'Settlement Period',
    'shareDetails-column-share-fee': 'Sharer Payout',
    'shareDetails-column-invite-fee': 'Invitee Payout',
    'shareDetails-column-settle-time': 'Settlement Time',
    'startCopy-no-desc': 'No introduction available',
    'startCopy-earning-rate': 'Return Rate',
    'startCopy-total-profit': 'Total P&L',
    'startCopy-follow-profit': 'Copy Returns',
    'startCopy-max-drawdown': 'Max Drawdown',
    'startCopy-fee-label-subscription': 'Subscription Fee',
    'startCopy-fee-label-performance': 'Profit Share',
    'startCopy-fee-start': 'from',
    'startCopy-leverage': 'Leverage',
    'startCopy-section-copy-account': 'Copy Account',
    'startCopy-account-balance': 'Balance',
    'startCopy-account-available': 'Available',
    'startCopy-account-margin': 'Margin Used',
    'startCopy-account-unrealized': 'Floating P&L',
    'startCopy-account-type-platform': 'Platform Account',
    'startCopy-symbol-section-title': 'Symbol',
    'startCopy-symbol-select-all': 'All',
    'startCopy-symbol-placeholder': 'Enter symbol',
    'startCopy-duration-title': 'Subscription Duration',
    'startCopy-follow-info-title': 'Copy Settings',
    'startCopy-direction-forward': 'Forward Copy',
    'startCopy-direction-reverse': 'Reverse Copy',
    'startCopy-follow-times-suffix': 'x',
    'startCopy-follow-times-placeholder': 'Enter multiplier',
    'startCopy-follow-times-tip':
      'Minimum copy multiplier 0.01 (1.00%). If it is below the minimum trade size, the minimum trade size will be used.',
    'startCopy-sltp-title': 'Take Profit / Stop Loss',
    'startCopy-optional': ' (Optional)',
    'startCopy-stop-loss-placeholder': 'Amount Stop Loss',
    'startCopy-take-profit-placeholder': 'Amount Take Profit',
    'startCopy-match-rules-title': 'Matching Rules',
    'startCopy-table-index': '#',
    'startCopy-table-signal-suffix': 'Signal Suffix',
    'startCopy-table-signal-symbol': 'Signal Symbol',
    'startCopy-table-my-suffix': 'Copy Suffix',
    'startCopy-table-my-symbol': 'Copy Symbol',
    'startCopy-placeholder-signal-suffix': 'Select signal suffix',
    'startCopy-placeholder-my-suffix': 'Select copy suffix',
    'startCopy-placeholder-signal-symbol': 'Select signal symbol',
    'startCopy-placeholder-my-symbol': 'Select copy symbol',
    'startCopy-no-suffix': 'No suffix',
    'startCopy-agreement-prefix':
      'By clicking "Confirm", I acknowledge that I have read, understood, and agree to the ',
    'startCopy-agreement-link': 'Copy Trading Service Agreement',
    'startCopy-agreement-suffix': '.',
    'startCopy-button-confirm': 'Confirm',
    'startCopy-validate-follow-times': 'Please enter copy multiplier',
    'startCopy-validate-agreement': 'Please accept the agreement',
    'startCopy-tab-suffix': 'Suffix Mapping',
    'startCopy-tab-symbol': 'Symbol Mapping',
    'startCopy-notify-password-title': 'Enter Password',
    'startCopy-notify-password-desc': 'Please enter a valid funding password',
    'main-no-account': 'No live account available',
    'main-account-balance': 'Balance',
    'main-account-available': 'Available',
    'main-account-margin': 'Margin Used',
    'main-account-unrealized': 'Floating P&L',
    'main-account-type-platform': 'Platform Account',
    'main-button-my-assets': 'My Copy Trades',
    'main-button-become-expert': 'Become a Trading Expert',
    'main-button-my-publish': 'My Publications',
    'main-heading-signal-plaza': 'Signal Plaza',
    'main-search-placeholder': 'Search',
    'main-tab-all': 'All',
    'main-tab-recommend': 'Recommended',
    'main-tab-earning': 'Top Returns',
    'main-tab-drawdown': 'Lowest Drawdown',
    'main-tab-fee': 'Lowest Subscription Fee',
    'main-column-signal-name': 'Signal Name',
    'main-column-signal-id': 'Signal ID',
    'main-column-fee': 'Pricing Model / Fee',
    'main-column-max-drawdown': 'Max Drawdown',
    'main-column-earning-rate': 'Return Rate',
    'main-column-total-profit': 'Total P&L',
    'main-column-follow-profit': 'Copy Returns',
    'main-column-create-time': 'Published At',
    'main-tag-subscription': 'Subscription Fee',
    'main-tag-profit-share': 'Profit Share',
    'status-running': 'Running',
    'status-paused': 'Paused',
    'status-stopped': 'Stopped',
    'status-cancelled': 'Cancelled',
    'status-pending-settle': 'Pending Settlement',
    'status-pending-redeem': 'Pending Redemption',
    'time-format-day': ' days',
    'time-format-hour': ' hours',
    'time-format-minute': ' minutes',
    'time-format-second': ' seconds',
    'editInfo-title': 'Edit Signal Info',
    'editInfo-label-name': 'Signal Name',
    'editInfo-placeholder-name': 'Enter signal name',
    'editInfo-label-description': 'Signal Description',
    'editInfo-placeholder-description': 'Enter signal description',
    'editInfo-label-photo': 'Signal Photo',
    'editInfo-validate-name': 'Please enter signal name',
    'editInfo-validate-description': 'Please enter signal description',
    'editInfo-validate-photo': 'Please select a signal photo',
    'editInfo-notify-success': 'Signal info updated successfully',
    'editInfo-notify-fail': 'Failed to update signal info',
  },
  archive: {
    'modal-title': 'Archive Signal',
    'operation-warning': 'This action cannot be undone',
    'agreement-text': 'I acknowledge and agree',
    'button-cancel': 'Cancel',
    'button-confirm': 'Confirm',
    'step1-title': 'Signal Preparation',
    'step1-desc': 'Open positions detected. Please close all orders before proceeding.',
    'step2-title': 'Submit Request',
    'step2-desc': 'Confirm and understand the outcome of archiving the signal.',
    'step3-title': 'What Happens Next?',
    'step3-detail-new':
      'For new investors: This signal will no longer be available for investment.',
    'step3-detail-existing':
      'For existing investors: All active investments will be closed and the signal becomes view-only.',
    'step3-detail-you':
      'For you: All active investments will be closed. Performance fees will be paid at the end of the settlement period.',
    'step3-detail-view-only': 'The signal will be view-only.',
    'notify-success-title': 'Success',
    'notify-success-desc': 'Signal archived successfully.',
  },
}
